import * as paperW from "./Paperwork";
import * as login from "./Login";
import * as backOffice from "./BackOffice";

export default {
  paperW,
  login,
  backOffice,
};
